export function useGradient(gradient) {
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d', { willReadFrequently: true });
  let canvasGradient = ctx.createLinearGradient(0, 0, 0, 256);

  canvas.width = 1;
  canvas.height = 256;

  for (var item in gradient) {
    canvasGradient.addColorStop(+item, gradient[item]);
  }

  ctx.fillStyle = canvasGradient;
  ctx.fillRect(0, 0, 1, 256);

  const data = ctx.getImageData(0, 0, 1, 256).data;

  /**
   *
   * @param {number} value
   * @param {'hex' | 'rgba' | 'arr'} type
   * @returns
   */
  function getColor(value, type) {
    const index = Math.floor(Math.min(value || 0, 1) * 255) * 4;

    const r = data[index];
    const g = data[index + 1];
    const b = data[index + 2];
    const a = data[index + 3] / 255;

    if (type === 'arr') {
      return [r, g, b, a];
    } else if (type === 'rgba') {
      return `rgba(${r},${g},${b},${a})`;
    } else if (type === 'hex') {
      return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
    }
  }

  return {
    getColor
  };
}
